import {dbParent} from './utils';
import firebase from "firebase";
import _ from "lodash";

export const createUser = (project_id, user_data) => {
  return dbParent('projects').doc(project_id).collection('users')
    .add(user_data);
}

export const getRole = async (id) => {
  const users = await firebase.firestore()
    .collection('projects')
    .doc(id)
    .collection('users')
    .where('uid', '==', firebase.auth().currentUser.uid)
    .get();

  let role = null;

  await users.forEach((sub) => {
    const data = sub.data();
    if (data) {
      role = data.role;
    }
  });

  return role;
}

const _usersCache = new Map(); // key -> { ts, promise }
const DEFAULT_TTL = 10_000; // 10 сек

export function getProjectUsersCached(projectId, { ttlMs = DEFAULT_TTL } = {}) {
  const key = `projectUsers:${projectId}`;
  const now = Date.now();
  const hit = _usersCache.get(key);
  if (hit && now - hit.ts < ttlMs) return hit.promise;

  // собираем промис запроса
  const p = firebase.firestore()
    .collection("projects")
    .doc(projectId)
    .collection("users")
    .get()
    .then((snap) => {
      const arr = [];
      snap.forEach((subDoc) => {
        const d = subDoc.data() || {};
        arr.push({
          id: subDoc.id,
          uid: d.uid || subDoc.id,
          name: d.name,
          email: d.email,
          _raw: d,
        });
      });
      return arr;
    })
    .catch(err => {
      _usersCache.delete(key);
      throw err;
    });

  _usersCache.set(key, { ts: now, promise: p });
  return p;
}

// точечная инвалидация (зови после добавления/обновления/удаления user'а)
export function invalidateProjectUsers(projectId) {
  _usersCache.delete(`projectUsers:${projectId}`);
}

export const getUsersOptions = async (id, ignoreAll = false, blockId = false, ttlMs = 10_000) => {
  const base = await getProjectUsersCached(id, { ttlMs });

  // формируем options из кешированного массива
  const result = base.map(u => ({
    label: u.name || u.email,
    value: blockId ? u.id : (u.uid || u.id),
    _data: { ...u._raw, id: u.id },
  }));

  if (!ignoreAll) {
    result.unshift({ label: "Все пользователи", value: null });
  }

  return _.uniqBy(result, "value");
};

export const getCompaniesOptions = async (id, blockId = false) => {
  const result = [];

  const data = await firebase.firestore()
    .collection('projects')
    .doc(id)
    .collection('users')
    .where('isCompany', '==', true)
    .get();

  await data.forEach((subDoc) => {
    let _data = subDoc.data();
    if(blockId) {
      result.push({label: _data.name || _data.email, value: subDoc.id, _data: _data});

    } else {
      result.push({label: _data.name || _data.email, value: _data.uid || subDoc.id, _data: _data});
    }
  });

  return _.uniqBy(result, 'value');
}



// WEBPACK FOOTER //
// ./src/firestore/users.js